import { useEffect } from 'react';

/**
 * ScrollToTopOnRouteChange
 * -------------------------
 * المشروع ده مش بيستخدم React Router (بيستخدم currentPage state بدل الـ URL)،
 * فبدل ما نراقب location زي مواقع React Router العادية، بنراقب currentPage نفسه.
 * كل ما القيمة دي تتغير (يعني المستخدم انتقل لصفحة جديدة زي فئة أو checkout إلخ)،
 * الصفحة بترجع لأعلى تلقائيًا بدل ما تفضل في نفس مكان السكرول القديم.
 *
 * الاستخدام في App.jsx:
 *   import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange.jsx';
 *   ...
 *   <ScrollToTopOnRouteChange currentPage={currentPage} />
 *   (حطها جوه الـ <div className="App"> فوق قبل <main>)
 */
const ScrollToTopOnRouteChange = ({ currentPage }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [currentPage]);

  return null;
};

export default ScrollToTopOnRouteChange;
